import React from 'react';

const INSETS = [40, 35, 30, 25, 20, 15, 10, 5, 0];

/**
 * Full-page wait rings. The original 250px Loader stays unchanged for PageLoader.
 */
const WaitGlass = () => (
  <div className="wait-rings">
    <div className="wait-rings-stage">
      {INSETS.map((inset, i) => (
        <div
          key={inset}
          className="wait-rings-band"
          style={{
            inset: `${inset}%`,
            animationDelay: `${i * 0.1}s`,
            borderColor: `rgba(210, 225, 255, ${Math.max(0.12, 0.38 - i * 0.03)})`,
          }}
        />
      ))}
    </div>
  </div>
);

export default WaitGlass;
